import React, { useId } from 'react';
import classnames from 'classnames';

import Show from 'components/Show';

const Textarea = ({ readOnly, label, placeholder, type, name, value, onChange, className, inputClassName }) => {
	// Generate random id once
	const id = useId();

	// Container's classnames
	const containerClassName = classnames(
		'flex flex-col',
		className
	);

	// Textarea's classnames
	const elementClassName = classnames(
		'py-2 px-3 w-full bg-transparent border border-neutral-200 dark:border-neutral-700 dark:text-white text-neutral-800 placeholder:text-neutral-400 rounded-lg focus:border-transparent focus:ring focus:ring-amber-500 read-only:cursor-not-allowed read-only:focus:ring-0 transition-colors',
		inputClassName
	);

	// Handle input's value change
	const handle = (event) => {
		onChange({
			name,
			value: event.target.value
		});
	};

	return (
		<div className={containerClassName}>
			{/* Show label only if passed */}
			<Show if={label}>
				<label
					htmlFor={id}
					className="mb-1 text-sm font-bold text-neutral-800 dark:text-white transition-colors"
				>
					{label}
				</label>
			</Show>

			<textarea
				id={id}
				rows="3"
				type={type}
				name={name}
				value={value}
				placeholder={placeholder}
				onChange={handle}
				readOnly={readOnly}
				className={elementClassName}
			/>
		</div>
	);
};

export default Textarea;